import React, { useEffect } from 'react';

export default function Toast({ mensaje, tipo = 'success', onCerrar }) {
  useEffect(() => {
    const timer = setTimeout(onCerrar, 3000);
    return () => clearTimeout(timer);
  }, [onCerrar]);

  const colores = {
    success: { bg: '#27AE60', icon: '✅' },
    danger:  { bg: '#E74C3C', icon: '❌' },
    warning: { bg: '#F39C12', icon: '⚠️' },
  };

  const color = colores[tipo] || colores.success;

  return (
    <div style={{
      position:     'fixed',
      bottom:       '24px',
      right:        '24px',
      background:   color.bg,
      color:        '#fff',
      padding:      '12px 20px',
      borderRadius: '10px',
      boxShadow:    '0 4px 20px rgba(0,0,0,0.2)',
      zIndex:       9999,
      display:      'flex',
      alignItems:   'center',
      gap:          '10px',
      minWidth:     '250px',
      animation:    'slideIn 0.3s ease',
    }}>
      <span>{color.icon}</span>
      <span className="fw-bold small">{mensaje}</span>
      <button
        onClick={onCerrar}
        style={{
          marginLeft: 'auto',
          background: 'none',
          border:     'none',
          color:      '#fff',
          cursor:     'pointer',
          fontSize:   '18px',
          padding:    '0',
        }}
      >×</button>
    </div>
  );
}